import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { CONTACT } from 'config/contact';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-primary/90 to-accent relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8">
          <div className="inline-flex items-center space-x-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium">
            <Icon name="Rocket" size={16} />
            <span>Start Your Automation Journey</span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-bold text-white leading-tight">
            Ready to Reclaim 40-70 Hours Monthly?
          </h2>

          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Join hundreds of businesses that have transformed their operations with intelligent workflow automation. Get started with a free automation audit today.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Link to="/contact">
              <Button 
                variant="secondary" 
                size="lg" 
                iconName="Calendar" 
                iconPosition="left"
                className="bg-white text-primary hover:bg-white/90"
              >
                Book Free Automation Audit
              </Button>
            </Link>
            <a href={CONTACT.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button 
                variant="outline" 
                size="lg" 
                iconName="MessageCircle" 
                iconPosition="left"
                className="border-white text-white hover:bg-white/10"
              >
                Chat on WhatsApp
              </Button>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 pt-12 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Clock" size={32} className="text-white" />
              </div>
              <p className="text-3xl font-bold text-white mb-2">40-70hrs</p>
              <p className="text-white/80 text-sm">Saved Monthly</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="TrendingUp" size={32} className="text-white" />
              </div>
              <p className="text-3xl font-bold text-white mb-2">95%</p>
              <p className="text-white/80 text-sm">Error Reduction</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="DollarSign" size={32} className="text-white" />
              </div>
              <p className="text-3xl font-bold text-white mb-2">$60K+</p>
              <p className="text-white/80 text-sm">Annual Savings</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;